export interface Collection {
  highlightsCount: number;
  id: string;
  name: string;
  created?: number;
  userId?: number;
  userName?: string;
  keyName?: string | null;
}

export const ALL_HIGHLIGHTS_ID = '0';
